export default {
      id: "color_carrot-usage",
      viewBox: "0 0 112.4 122.8",
      url: __webpack_public_path__ + "sprite.svg#color_carrot",
      toString: function () {
        return this.url;
      }
    }